(() => {
  if (window.__ffcSaAjaxBridge) return;
  window.__ffcSaAjaxBridge = true;
  const cache = new Map();
  const section = () => document.querySelector('[data-wetheme-section-type="template--product"]');
  const path = (u) => { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch { return ''; } };
  const targetUrl = (el) => {
    const raw = el?.getAttribute('href') || el?.getAttribute('data-product-url') || el?.getAttribute('data-url');
    if (!raw) return null;
    try {
      const u = new URL(raw, location.href);
      return u.origin === location.origin && u.pathname.includes('/products/') ? u : null;
    } catch { return null; }
  };
  const clickable = (t) => t?.closest?.('a[href], [data-product-url], [data-url]');
  const excluded = '.cross-sell,.complementary-products,[data-product-recommendations],product-recommendations,.quick-add-wrapper,.recently-viewed-products';
  const groupRoot = (el) => {
    const main = section();
    if (!main || !main.contains(el) || el.closest(excluded)) return null;
    let node = el.parentElement;
    while (node && node !== main) {
      const links = [...node.querySelectorAll('a[href*="/products/"], [data-product-url*="/products/"], [data-url*="/products/"]')];
      const urls = new Set(links.map((x) => path(targetUrl(x)?.href || '')).filter(Boolean));
      if (urls.size >= 2 && node.getBoundingClientRect().height < 500) return node;
      node = node.parentElement;
    }
    return null;
  };
  const fetchSection = async (url, id) => {
    const key = `${url.pathname}${url.search}|${id}`;
    if (!cache.has(key)) {
      const u = new URL(url.href);
      u.searchParams.set('section_id', id);
      cache.set(key, fetch(u.href, { credentials: 'same-origin' }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      }));
    }
    try { return await cache.get(key); } catch (e) { cache.delete(key); throw e; }
  };
  const swap = async (url, clicked, push = true) => {
    const main = section();
    const info = main?.querySelector('product-information');
    const id = main?.dataset.wethemeSectionId;
    if (!info || !id || typeof info.replaceElements !== 'function') throw new Error('theme bridge unavailable');
    const html = await fetchSection(url, id);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('product-information');
    const productURL = next?.getAttribute('data-url');
    if (!next || !productURL) throw new Error('target product unavailable');
    const oldTitle = info.querySelector('h1')?.textContent?.trim() || '';
    const newTitle = next.querySelector('h1')?.textContent?.trim() || '';
    const prior = info.isCombinedListing;
    info.isCombinedListing = true;
    info.replaceElements(doc, { productURL, isCombinedListing: true });
    info.isCombinedListing = prior;
    info.mainProductURL = productURL;
    info.productUrl = productURL;
    info.dataset.url = productURL;
    const variant = next.querySelector('input[name="id"]');
    if (variant?.value) info.currentVariant = { id: Number(variant.value), available: !variant.disabled };
    if (push) history.pushState({ ffcSaAjax: true }, '', url.href);
    if (oldTitle && newTitle && document.title.includes(oldTitle)) document.title = document.title.replace(oldTitle, newTitle);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = `${url.origin}${url.pathname}`;
    const root = clicked ? groupRoot(clicked) : null;
    if (root) {
      [...root.querySelectorAll('a[href], [data-product-url], [data-url]')].forEach((x) => {
        const active = path(targetUrl(x)?.href || '') === path(url.href);
        x.toggleAttribute('aria-current', active);
        ['active','selected','is-active','is-selected','current'].forEach((c) => x.classList.toggle(c, active));
      });
    }
    window.Shopify?.PaymentButton?.init?.();
  };
  const qualifies = (el, url) => !!(el && url && path(url.href) !== path(location.href) && groupRoot(el));
  const prefetch = (t) => {
    const el = clickable(t), url = targetUrl(el);
    if (!qualifies(el, url)) return;
    const id = section()?.dataset.wethemeSectionId;
    if (id) fetchSection(url, id).catch(() => {});
  };
  document.addEventListener('pointerover', (e) => prefetch(e.target), { passive: true });
  document.addEventListener('touchstart', (e) => prefetch(e.target), { passive: true });
  window.addEventListener('click', (e) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const el = clickable(e.target), url = targetUrl(el);
    if (!qualifies(el, url)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    swap(url, el).catch(() => { location.href = url.href; });
  }, true);
  window.addEventListener('popstate', () => {
    const url = new URL(location.href);
    if (!url.pathname.includes('/products/')) return;
    swap(url, null, false).catch(() => location.reload());
  });
  window.addEventListener('ffc:linked-product-click', (event) => {
  const rawUrl = event.detail?.url;
  if (!rawUrl) return;

  const url = new URL(rawUrl, location.href);

  if (url.origin !== location.origin) return;

  if (path(url.href) === path(location.href)) return;

  swap(url, null).catch((error) => {
    console.error('FFC linked product switch failed:', error);
    location.href = url.href;
  });
});
})();